export class ENV {
  public static SERVER_API_URL = "https://dev-api.rnwsys.com/branch/v3";
}



// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts